import { compose } from 'recompose'
import { withFirestoreUser } from './withFirestoreUser'
import { withNonAnonymousAccess } from './withNonAnonymousAccess'

export const withFullyAuthenticatedUser = compose(withNonAnonymousAccess, withFirestoreUser)
